import { Component, OnInit, Input, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ComponentService } from '../../services/component.service';
import { DxTagBoxModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-dynamic-select',
  templateUrl: './dynamic-select.component.html',
  styleUrls: ['./dynamic-select.component.css']
})
export class DynamicSelectComponent implements OnInit {
  @ViewChild('dynamicSelect', { static: false }) dynamicSelect: ElementRef<HTMLInputElement>;
  @Input() isOpen: boolean = false; // Gestisce se la select è aperta
  @Input() dataSourceType: 'api' | 'odata' | 'static' = 'odata'; // Tipo di sorgente dati 
  @Input() staticOptions: Array<{ value: string, display: string }> = []; // Dati statici
  @Input() apiEndpoint?: string; // Endpoint API per il recupero dati
  @Input() odataEndpoint?: string; // Endpoint OData per il recupero dati
  options: Array<{ value: string, display: string }> = []; // Opzioni da visualizzare
  @Input() label: string = '';
  @Input() dataInput: any;
  @Input() odataQueryString: string = '';
  fields: any[];
  filteredOptions: Array<{ value: string, display: string }> = [];

  searchText = '';
  isDX: boolean = false;

  // risolviamo il problema del mantenere i filtri selezionati
  selectedValues: Set<string> = new Set();  // Usa un Set per evitare duplicati
  constructor(private http: HttpClient, private cdr: ChangeDetectorRef) { }

  
  ngOnInit(): void {
    this.loadOptions();
  }

  loadOptions(): void {
    switch (this.dataSourceType) {
      case 'static':
        this.setOptions(this.staticOptions);
        break;
      case 'api':
        this.loadOptionsFromApi();
        break;
      case 'odata':
        this.loadOptionsFromOData();
        break;
    }
  }

  setOptions(data: Array<{ value: string, display: string }>) {
    this.options = data;
    this.filterOptions(); // Make sure to filter options right after setting them
  }

  loadOptionsFromApi(): void {
    if (!this.apiEndpoint) {
      console.log("No API endpoint provided, skipping API data load.");
      return;
    }
    const apiUrl = `${environment.BASE_API_URL}${this.apiEndpoint}`;
    this.http.get<any>(apiUrl).subscribe(data => {
      this.setOptions(data.items.map(item => ({ value: item.id.toString(), display: item.descrizione })));
    }, error => console.error('Error fetching data from API:', error));
  }

  loadOptionsFromOData(): void {
    if (!this.odataEndpoint) {
      console.error("Attempted to load OData without an OData endpoint.");
      return;
    }
    const odataUrl = `${environment.BASE_API_URL}${this.odataEndpoint}${this.odataQueryString}`;
    this.http.get<any>(odataUrl).subscribe(data => {
      this.setOptions(data.items.map(item => ({ value: item.id.toString(), display: item.descrizione })));
      this.cdr.detectChanges();
    }, error => console.error('Error fetching OData:', error));
  }

  filterOptions(): void {
    this.filteredOptions = this.searchText ? this.options.filter(option =>
      option.display.toLowerCase().includes(this.searchText.toLowerCase())
    ) : this.options;
  }

  toggleSelection(value: string, event: MouseEvent): void {
    event.preventDefault(); // Prevent the default behavior of the select element
    if (this.selectedValues.has(value)) {
      this.selectedValues.delete(value);
    } else {
      this.selectedValues.add(value);
    }
    this.cdr.markForCheck(); // Ensure the change detection cycle is run
  }
}